var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "placeholder-page"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('div', {
    staticClass: "header-content"
  }, [_c('div', {
    staticClass: "header-icon"
  }, [_c('v-icon', {
    attrs: {
      "size": "48",
      "color": "primary"
    }
  }, [_vm._v(_vm._s(_vm.icon))])], 1), _c('h1', {
    staticClass: "page-title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('p', {
    staticClass: "page-description"
  }, [_vm._v(_vm._s(_vm.description))])])]), _c('div', {
    staticClass: "page-content"
  }, [_c('v-container', [_c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "8",
      "lg": "6"
    }
  }, [_c('v-card', {
    staticClass: "coming-soon-card",
    attrs: {
      "elevation": "8"
    }
  }, [_c('v-card-text', {
    staticClass: "pa-8 text-center"
  }, [_c('div', {
    staticClass: "coming-soon-icon"
  }, [_c('v-icon', {
    staticClass: "mb-6",
    attrs: {
      "size": "80",
      "color": "primary"
    }
  }, [_vm._v("mdi-rocket-launch")])], 1), _c('h2', {
    staticClass: "coming-soon-title"
  }, [_vm._v("Coming Soon")]), _c('p', {
    staticClass: "coming-soon-description"
  }, [_vm._v(" We're working hard to bring you this feature. Stay tuned for updates! ")]), _c('div', {
    staticClass: "feature-preview"
  }, [_c('div', {
    staticClass: "preview-item"
  }, [_c('v-icon', {
    staticClass: "mb-2",
    attrs: {
      "size": "24",
      "color": "success"
    }
  }, [_vm._v("mdi-check-circle")]), _c('span', {
    staticClass: "preview-text"
  }, [_vm._v("Advanced functionality")])], 1), _c('div', {
    staticClass: "preview-item"
  }, [_c('v-icon', {
    staticClass: "mb-2",
    attrs: {
      "size": "24",
      "color": "success"
    }
  }, [_vm._v("mdi-check-circle")]), _c('span', {
    staticClass: "preview-text"
  }, [_vm._v("Real-time updates")])], 1), _c('div', {
    staticClass: "preview-item"
  }, [_c('v-icon', {
    staticClass: "mb-2",
    attrs: {
      "size": "24",
      "color": "success"
    }
  }, [_vm._v("mdi-check-circle")]), _c('span', {
    staticClass: "preview-text"
  }, [_vm._v("Mobile optimized")])], 1)]), _c('div', {
    staticClass: "action-buttons"
  }, [_c('v-btn', {
    staticClass: "mr-4",
    attrs: {
      "color": "primary",
      "size": "large"
    },
    on: {
      "click": _vm.goBack
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-arrow-left")]), _vm._v(" Go Back ")], 1), _c('v-btn', {
    attrs: {
      "outlined": "",
      "size": "large"
    },
    on: {
      "click": _vm.notifyMe
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-bell")]), _vm._v(" Notify Me ")], 1)], 1)])], 1)], 1)], 1), _c('v-row', {
    staticClass: "mt-8"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("Related Features")])]), _vm._l(_vm.relatedFeatures, function (feature) {
    return _c('v-col', {
      key: feature.title,
      attrs: {
        "cols": "12",
        "md": "4"
      }
    }, [_c('v-card', {
      staticClass: "feature-card",
      attrs: {
        "elevation": "4"
      },
      on: {
        "click": function ($event) {
          return _vm.navigateTo(feature.route);
        }
      }
    }, [_c('v-card-text', {
      staticClass: "pa-6"
    }, [_c('div', {
      staticClass: "feature-icon"
    }, [_c('v-icon', {
      attrs: {
        "size": "32",
        "color": feature.color
      }
    }, [_vm._v(_vm._s(feature.icon))])], 1), _c('h4', {
      staticClass: "feature-title"
    }, [_vm._v(_vm._s(feature.title))]), _c('p', {
      staticClass: "feature-description"
    }, [_vm._v(_vm._s(feature.description))]), _c('v-btn', {
      staticClass: "mt-4",
      attrs: {
        "text": "",
        "color": "primary"
      },
      on: {
        "click": function ($event) {
          $event.stopPropagation();
          return _vm.navigateTo(feature.route);
        }
      }
    }, [_vm._v(" Explore "), _c('v-icon', {
      attrs: {
        "right": ""
      }
    }, [_vm._v("mdi-arrow-right")])], 1)], 1)], 1)], 1);
  })], 2)], 1)], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }